var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1001,
    height: 894,
    viewBox: "0 0 1001 894",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_531_113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M463.584 573.014L418.725 536.791C400.028 521.694 379.04 509.681 356.553 501.206C313.856 485.114 277.043 456.455 250.97 419.01L216.377 369.329C203.922 351.441 198.692 329.505 201.737 307.922L213.125 227.19C216.183 205.517 240.135 193.757 259.153 204.593C261.376 205.859 263.747 206.846 266.212 207.53L390.5 242L573.361 297.497C603.963 306.785 633.08 320.4 659.829 337.929L671.045 345.279C704.931 367.486 733.502 396.894 754.721 431.407L778.532 470.136C795.986 498.525 803.225 532.022 799.051 565.085C791.486 625.008 746.922 674.36 688.315 688.96C659.708 696.087 629.197 694.638 601.478 684.597L592.278 681.264C561.979 670.288 535.172 651.401 514.639 626.564L500.72 609.725C489.601 596.276 477.16 583.977 463.584 573.014Z",
    fill: "#141414"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_531_113",
    x: 0.889771,
    y: 0.5,
    width: 999.313,
    height: 892.9,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_531_113"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector6);
export default __webpack_public_path__ + "static/media/Vector6.18e72a78ac6432e99f53b71ad8ab3179.svg";
export { ForwardRef as ReactComponent };